export enum BOOKING_STATUS_ENUM {
    Loading = 'loading',
    NotFound = 'not_found',
    Pending = 'pending',
    InQueue = 'in_queue',
    WaitingPartner = 'waiting_partner',
    CalledClient = 'called_client',
    InProgress = 'in_progress',
    Completed = 'completed',
    Cancelled = 'cancelled',
    CancelledByAdmin = 'cancelled_by_admin',
    NoShow = 'no_show',
}

export type BookingStatus = BOOKING_STATUS_ENUM
